import { twMerge } from "tailwind-merge";
import { parseISO, format, addHours } from "date-fns";
import { DATE_FORMATS } from "../../contanst/dateTimeConstants";

export function cn(...classes) {
  return twMerge(...classes);
}

export const calculateDaysLeft = (expireTime) => {
  if (!expireTime) return "Invalid date";

  const today = new Date();
  const targetDate = new Date(expireTime);

  const timeDiff = targetDate - today;

  if (timeDiff < 0) return "Expired";

  const daysLeft = Math.ceil(timeDiff / (1000 * 60 * 60 * 24));
  return `${daysLeft} days left`;
};

// export const calculateDays = (expireTime) => {
//   if (!expireTime) return "Invalid date";

//   const today = new Date();
//   const targetDate = new Date(expireTime);

//   const timeDiff = targetDate - today;

//   if (timeDiff < 0) return "Expired";

//   const daysLeft = Math.ceil(timeDiff / (1000 * 60 * 60 * 24));
//   return `${daysLeft} days`;
// };

export const calculateDays = (expireTime) => {
  if (!expireTime) return "0";

  const today = new Date();
  const targetDate = new Date(expireTime);
  const timeDiff = targetDate - today;

  if (timeDiff < 0) {
    return Math.ceil(Math.abs(timeDiff) / (1000 * 60 * 60 * 24)).toString();
  }

  return Math.ceil(timeDiff / (1000 * 60 * 60 * 24)).toString();
};

export const getTimeStatus = (expireTime) => {
  if (!expireTime) return { days: "0", isPast: false };

  const today = new Date();
  const targetDate = new Date(expireTime);

  // Chỉ so sánh phần ngày, tháng, năm mà không tính giờ phút giây
  const todayWithoutTime = new Date(
    today.getFullYear(),
    today.getMonth(),
    today.getDate()
  );
  const targetWithoutTime = new Date(
    targetDate.getFullYear(),
    targetDate.getMonth(),
    targetDate.getDate()
  );

  const timeDiff = targetWithoutTime - todayWithoutTime;
  const isPast = timeDiff < 0;

  const millisecondsPerDay = 1000 * 60 * 60 * 24;
  const daysDiff = Math.abs(Math.round(timeDiff / millisecondsPerDay));

  if (targetWithoutTime.getTime() === todayWithoutTime.getTime()) {
    return { days: "0", isPast, isSameDay: true };
  }

  return { days: daysDiff.toString(), isPast, isSameDay: false };
};

// helpers/dateFormatter.js

export const formatDate = (dateInput) => {
  const date = dateInput instanceof Date ? dateInput : new Date(dateInput);

  if (isNaN(date.getTime())) {
    return "Invalid Date";
  }

  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  const day = date.getDate();
  const month = months[date.getMonth()];
  const year = date.getFullYear();

  return `${day} ${month} ${year}`;
};

export const capitalizeFirstLetter = (string) => {
  if (!string) return string; // Handle empty or null strings
  return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
};

export const formatQuestionType = (type) => {
  const map = {
    mcq: "MCQ",
    choice: "Choice",
    essay: "Essay",
    yes_no: "Yes / No",
    checkbox: "Checkbox",
    slider: "Slider",
    short: "Short",
    long: "Long",
  };

  return map[type] || "Other";
};
export const convertToUTC = (localTimeString) => {
  const localDate = new Date(localTimeString);
  const year = localDate.getUTCFullYear();
  const month = String(localDate.getUTCMonth() + 1).padStart(2, "0");
  const day = String(localDate.getUTCDate()).padStart(2, "0");
  const hours = String(localDate.getUTCHours()).padStart(2, "0");
  const minutes = String(localDate.getUTCMinutes()).padStart(2, "0");
  const seconds = String(localDate.getUTCSeconds()).padStart(2, "0");

  return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
};

export const convertToLocalTime = (utcTimeString) => {
  const utcDate = new Date(utcTimeString);
  const year = utcDate.getFullYear();
  const month = String(utcDate.getMonth() + 1).padStart(2, "0"); // getMonth() is 0-based
  const day = String(utcDate.getDate()).padStart(2, "0");
  const hours = String(utcDate.getHours()).padStart(2, "0");
  const minutes = String(utcDate.getMinutes()).padStart(2, "0");
  const seconds = String(utcDate.getSeconds()).padStart(2, "0");

  return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
};

export const convertToSingaporeTime = (
  timestamp,
  formatPattern = DATE_FORMATS.DEFAULT
) => {
  if (!timestamp) return "";

  try {
    const parsedDate = parseISO(timestamp);

    if (isNaN(parsedDate.getTime())) {
      return "Invalid date";
    }

    const singaporeTime = addHours(parsedDate, 8);

    return format(singaporeTime, formatPattern);
  } catch (error) {
    console.error("Error converting to Singapore time:", error);
    return timestamp;
  }
};
